import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://eca-sso.videotron.com/auth",
  realm: 'marvel',
  clientId: "wsc-frontend",
});

export default keycloak;
